import { useCallback } from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import MuiMenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  item: {
    height: theme.height.small,
    minWidth: theme.marginBase * 10,
    paddingRight: theme.marginBase * 2,
    paddingLeft: theme.marginBase * 2,
  },
}));

interface Props extends MenuItemProps {
  label?: string;
  className?: string;
  value?: any;
  button?: undefined;
  onSelect?: (val: any) => any;
}

export const MenuItem = ({
  label,
  value,
  className,
  onSelect,
  onClick,
  children,
  ...rest
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const val = value || label;

  const onMenuClick = useCallback(
    (e: any) => {
      if (onClick) {
        onClick(e);
      }
      if (onSelect) {
        onSelect(value);
      }
    },
    [onSelect, onClick, value],
  );

  return (
    <MuiMenuItem
      value={val}
      className={classnames(classes.item, className)}
      onClick={onMenuClick}
      {...rest}
    >
      {children || label}
    </MuiMenuItem>
  );
};
